import { render, staticRenderFns } from "./ChartTab.vue?vue&type=template&id=05ef3ee2"
import script from "./ChartTab.vue?vue&type=script&lang=js"
export * from "./ChartTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports